import { useSelector } from "react-redux";

const readWindowFlag = (flag) => typeof window !== "undefined" && !!window[flag];

// A/B Test: Box size selector - V1: 6→12→16→20, V2: 8→12→16→20
export const isVariant1165V1 = () => readWindowFlag("_variant_1165_v1");
export const isVariant1165V2 = () => readWindowFlag("_variant_1165_v2");

// A/B Test: Discount percentage badge on bundle variant selectors
export const showDiscountBadge = () => readWindowFlag("_variant_discount_badge_1");

export const useABTestFlag = (readFlag) => {
	const isClient = useSelector((state) => state.global.isClient);
	return isClient && readFlag();
};
